import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import EraType from '@/roc/era/EraType';

const DragonShipEllida = {
  id: '72',
  name: 'DragonShip Ellida',
  era: EraType.earlyRome,
  icon: 'de',
  gameId: 'DragonshipEllida',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.NAVAL,
  kindMultiplier: 2,
  owner: WonderOwner.VIKINGS,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.CAVALRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        2.5,
        3.2,
        3.7,
        4.2,
        4.5,  // 5
        4.9,
        5.2,
        5.4,
        5.7,
        5.9, // 10
        6.2,
        6.4,
        6.6,
        6.8,
        7.0, // 15
        7.1,
        7.3,
        7.5,
        7.6,
        7.8, // 20
        7.9,
        8.1,
        8.2,
        8.4,
        8.5, // 25
        8.6,
        8.8,
        8.9,
        9.0,
        9.1  // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.DOCK_WORKER_TIME_BONUS,
      EffectAmount.asPerLevel([
        10.0,
        14.0,
        16.0,
        19.3,
        25.0,  // 5
        26.8,
        28.4,
        29.9,
        31.3,
        35.0, // 10
        36.2,
        37.4,
        38.5,
        39.5,
        45.0, // 15
        46.0,
        46.9,
        47.8,
        48.7,
        55.0, // 20
        55.8,
        56.6,
        57.4,
        58.2,
        65.0, // 25
        65.7,
        66.4,
        67.1,
        67.8,
        75.0  // 30
      ]),
      '%',
    ),
  ]),
  synergies: [],
};

export default DragonShipEllida;
